import { CSSProperties, FC, PropsWithChildren } from 'react';
type DesktopNavContainerProps = PropsWithChildren<{
  style?: CSSProperties;
}>;
export const DesktopNavContainer: FC<DesktopNavContainerProps> = ({
  children,
  style
}) => <div className="flex items-center h-full" style={style} data-sentry-component="DesktopNavContainer" data-sentry-source-file="navigation-desktop.tsx">
    {children}
  </div>;